const Loading = ({ placeholder }: IPropsLoading) => {
    return <>
        <input className={'input-field-vida-cr'} type='text' placeholder={placeholder} disabled />
    </>
}

export { Loading }